import { IFCViewer } from '@features/constructor/presentation/components/ifc-model/ifc-viewer/ifc-viewer.class';
import { useLayoutEffect, useRef } from 'react';
export var useIFCViewer = function (conatiners, options) {
    var currentViewer = useRef(null);
    useLayoutEffect(function () {
        var isExists = Object.values(conatiners).every(function (c) { return !!c.current; });
        if (isExists) {
            currentViewer.current = new IFCViewer(conatiners, options);
        }
        return function () {
            if (currentViewer.current) {
                currentViewer.current.destroy();
                currentViewer.current = null;
            }
        };
    }, []);
    return { currentViewer: currentViewer };
};
